<!--
 * @message: 多语言输入组件
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-09-07 17:14:05
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_inputTextFiled_multiLang.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-06-01 13:24:36
-->
<template>
  <div class="d-flex justify-start flex-column">
    <v-sheet class="d-inline-block text-truncate">
      <span :class="labelClass" v-if="showLabel">
        {{ label }}
        ({{
          companyLang
            ? companyLang.filter((ele) => ele.is_default)[0]["text"]
            : null
        }})
        <!-- 调试： {{ dataArr }} -->
      </span>
    </v-sheet>
    <v-input
      :messages="messages"
      :success="success"
      :success-messages="successMsg"
      :error="isError"
      :error-messages="errorMsg"
      :hide-details="false"
      :error-count="errorCount"
      :hint="hint"
      :dense="dense"
      :persistent-hint="persistentHint"
    >
      <v-menu
        color="white"
        ref="langmenu"
        class="rounded-lg"
        :elevation="4"
        disable-keys
        v-model="showMenu"
        transition="slide-y-transition"
        :close-on-content-click="false"
        :close-on-click="true"
      >
        <!-- :label="label"  去掉placehelder 2020-03-04 mel bug1511 -->
        <template v-slot:activator="{ attrs, on, value }">
          <v-text-field
            :dense="dense"
            v-on="readonly ? null : on"
            v-model="defaultValue"
            v-bind="attrs"
            :height="height"
            v-if="!textArea"
            :rules="canFocus ? rules : []"
            @focus="onFocus"
            :filled="readonly ? false : filled"
            :single-line="singleLine"
            :hide-details="hideDetails"
            @keydown="onKeyDown(defaultKey)"
            :error="isError"
            class="text-field-width"
            :disabled="disabled"
            :readonly="true"
            @update:error="onError"
            :append-icon="appendIcon"
            :prepend-icon="prependIcon"
            @click:append="$emit('appendClick')"
            @click:prepend="$emit('prependClick')"
          >
            <!-- 地球按钮 -->
            <template v-slot:append>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    :small="readonly"
                    v-on="showMenu ? null : on"
                    ref="langu"
                    :style="{
                      marginTop: readonly ? '0px' : '3px',
                      right: readonly ? '0px' : '-12px',
                    }"
                    @click="showMenu = true"
                  >
                    <i class="material-icons-round">{{ appendIcon }}</i>
                  </v-btn>
                </template>
                <span>{{
                  $t("message_essweb_language_components_earthTip")
                }}</span>
              </v-tooltip>
            </template>
            <!-- 地球按钮 -->
          </v-text-field>
          <!-- :label="label"  去掉placehelder 2020-03-04 mel bug1511 -->
          <v-textarea
            rows="3"
            no-resize
            :dense="dense"
            v-on="readonly ? null : on"
            v-model="defaultValue"
            v-bind="attrs"
            v-if="textArea"
            :rules="canFocus ? rules : []"
            @focus="onFocus"
            :filled="readonly ? false : filled"
            :single-line="singleLine"
            :hide-details="hideDetails"
            @keydown="onKeyDown(defaultKey)"
            :error="isError"
            class="text-field-width"
            :disabled="disabled"
            :readonly="true"
            maxlength="150"
            counter="150"
            :append-icon="appendIcon"
            :prepend-icon="prependIcon"
            @click:append="$emit('appendClick')"
            @click:prepend="$emit('prependClick')"
          >
            <!-- 地球按钮 -->
            <template v-slot:append>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                    :small="readonly"
                    ref="langu2"
                    @click="showMenu = true"
                    :disabled="ban"
                    :style="{
                      marginTop: readonly ? '0px' : '3px',
                      right: readonly ? '0px' : '-12px',
                    }"
                  >
                    <i class="material-icons-round">{{ appendIcon }}</i>
                  </v-btn>
                </template>
                <span>Multi-Language supported</span>
              </v-tooltip>
            </template>
            <!-- 地球按钮 -->
          </v-textarea>
        </template>
        <!-- 弹出窗口 -->
        <v-container fluid class="white rounded-lg pa-3">
          <!-- 去掉form，和外层容器使用同一个表单验证 -->
          <!-- <v-form ref="langform"> -->
          <template v-for="(item, index) in companyLang">
            <v-sheet :key="`language${index}`">
              <v-sheet>
                <span
                  class="text--secondary"
                  :class="isRequire ? 'mrc_text_require' : ''"
                >
                  {{ item["text"] }}
                  <!-- <span v-if="item.is_default">(Default Language)</span> -->
                </span>
              </v-sheet>
              <v-text-field
                v-model="valueArr[item['value']]"
                v-if="!textArea"
                :autofocus="index == 0 && !readonly ? true : false"
                :hint="hint"
                :height="height"
                :maxlength="maxlength"
                class="text-field-width"
                :rules="canFocus ? rules : []"
                :readonly="readonly"
                :filled="readonly ? false : filled"
                :placeholder="readonly ? '' : placeholder"
                @change="valueChange"
                @keydown="onKeyDown(item['value'])"
                :single-line="singleLine"
                :persistent-hint="persistentHint"
                :clearable="clearable"
                :loading="loading"
                :flat="flat"
                :dense="dense"
                :disabled="disabled"
              ></v-text-field>
              <v-textarea
                rows="3"
                no-resize
                v-model="valueArr[item['value']]"
                :autofocus="index == 0 && !readonly ? true : false"
                :hint="hint"
                v-if="textArea"
                :maxlength="maxlength"
                :counter="maxlength"
                class="text-field-width"
                :rules="canFocus ? rules : []"
                :readonly="readonly"
                :filled="readonly ? false : filled"
                :placeholder="readonly ? '' : placeholder"
                @change="valueChange"
                @keydown="onKeyDown(item['value'])"
                :single-line="singleLine"
                :persistent-hint="persistentHint"
                :clearable="clearable"
                :loading="loading"
                :flat="flat"
                :dense="dense"
                :disabled="disabled"
              ></v-textarea>
            </v-sheet>
          </template>
          <!-- </v-form> -->
          <v-container fluid class="d-flex pa-3 pt-6 pb-6" v-if="!readonly">
            <v-spacer></v-spacer>
            <v-btn
              text
              small
              color="primary"
              :ripple="false"
              rounded
              height="34"
              class="text-button mr-2"
              @click="
                handClose = true;
                onCancel();
              "
              >{{ $t("label_essweb_form_tools_cancelBtnLabel") }}</v-btn
            >
            <v-btn
              rounded
              small
              height="34"
              color="primary"
              class="text-button pr-6 pl-6"
              @click="
                handClose = true;
                onConfirm();
              "
              >{{ $t("label_essweb_form_tools_oKBtnLabel") }}</v-btn
            >
          </v-container>
        </v-container>
      </v-menu>
    </v-input>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "Mrc_language_input",
  computed: {
    ...mapGetters(["companyLang", "staticZone", "pageTriger"]),
    isRequire() {
      return this.rules.length ? true : false;
    },
    labelClass() {
      let cla = " ";
      if (this.isRequire) {
        cla += " mrc_text_require";
      }
      if (this.showMenu) {
        cla += " primary--text";
      }
      if (this.isError) {
        cla += " red--text";
      } else {
        cla += " text--secondary";
      }
      return cla;
    },
    isError() {
      // if (this.pageTriger && this.rules) {
      //   return this.isObjectNull(this.valueArr);
      // }

      if (!this.canFocus) {
        return false;
      }
      if (this.rules == null || this.rules.length == 0) {
        return false;
      }
      return this.isObjectNull(this.valueArr);
    },
    valueArr() {
      const that = this;
      var data = {};
      if (this.bindData && this.companyLang) {
        this.companyLang.forEach(function (item) {
          if (item.is_default) {
            that.defaultKey = item["value"];
          }
          data[item["value"]] = that.bindData[item["value"]];
        });
      } else {
        this.companyLang.forEach(function (item) {
          if (item.is_default) {
            that.defaultKey = item["value"];
          }
          data[item["value"]] = "";
        });
      }
      return data;
    },
    defaultValue: {
      get() {
        const that = this;
        if (that.companyLang) {
          for (let index = 0; index < that.companyLang.length; index++) {
            if (that.companyLang[index].is_default) {
              return that.bindData[that.companyLang[index]["value"]];
            }
          }
        } else {
          return "";
        }
      },
      set(val) {
        return val;
      },
    },
  },
  props: {
    // 数据
    bindData: {
      default: function () {
        return {};
      },
      type: [Object, String],
    },
    //规则
    rules: {
      default: function () {
        return [];
      },
      type: Array,
    },
    messages: { default: "", type: [String, Array] },
    errorCount: { default: 1, type: Number },
    label: { default: "Label", type: String },
    showLabel: { default: true, type: Boolean },
    placeholder: { default: "", type: [String, Function, Array] },
    hint: { default: "", type: String },
    singleLine: { default: true, type: Boolean },
    filled: { default: true, type: Boolean },
    persistentHint: { default: false, type: Boolean },
    hideDetails: { default: true, type: Boolean },
    canscroll: { default: true, type: Boolean },
    error: { default: false, type: Boolean },
    disabled: { default: false, type: Boolean },
    textArea: { default: false, type: Boolean },
    success: { default: false, type: Boolean },
    loading: { default: false, type: Boolean },
    clearable: { default: false, type: Boolean },
    maxlength: { default: 150, type: [String, Number, Array, Object] },
    flat: { default: false, type: Boolean },
    dense: { default: true, type: Boolean },
    successMsg: { default: "", type: String },
    height: { default: undefined, type: [String, Number] },
    readonly: { default: false, type: Boolean },
    appendIcon: { default: "language", type: String },
    prependIcon: { default: "", type: String },
    banOn: { default: false, type: Boolean }, //初始化禁止点击地球按钮
    TrigerInit: { default: "", type: [String, Boolean, Object, Array] }, //强制初始化
  },
  data() {
    return {
      showMenu: false,
      handClose: false,
      ban: false,
      isFirst: true,
      defaultKey: "",
      dataArr: "",
      canFocus: false,
      curKey: "",
      errorMsg: "",
    };
  },
  destroyed() {
    document.onkeydown = undefined; //解绑
  },
  watch: {
    TrigerInit(val) {
      //初始化输入组件， 解决弹窗多语言输入总是恢复到上次输入的值
      if (!val) {
        const that = this;
        this.$Sleep(1000).then(() => {
          that.dataArr = that.$getCommonLangKey(that.companyLang);
          that.onCancel();
        });
      }
    },
    showMenu(val) {
      const that = this;
      if (val) {
        that.ban = false;
        that.handClose = false;
        document.onkeydown = function (e) {
          var theEvent = e || window.event;
          var code = theEvent.keyCode || theEvent.which || theEvent.charCode;
          if (code == 13) {
            that.handClose = true;
            that.onConfirm();
            return false;
          }
          // if (code == 27) {
          //   that.handClose = true;
          //   that.onCancel();
          //   return false;
          // }
          return true;
        };
      } else {
        if (!that.handClose) {
          that.onCancel();
          document.onkeydown = undefined; //解绑
        }
      }
    },
    pageTriger(val) {
      if (val) this.canFocus = true;
    },
    bindData(val, old) {
      const that = this;
      var data = {};
      if (val && this.companyLang) {
        this.companyLang.forEach(function (item) {
          if (item.is_default) {
            that.defaultKey = item["value"];
          }
          data[item["value"]] = val[item["value"]];
        });
      } else {
        this.companyLang.forEach(function (item) {
          if (item.is_default) {
            that.defaultKey = item["value"];
          }
          data[item["value"]] = "";
        });
      }

      if (!old && this.isFirst) {
        //编辑模式首次取直
        this.isFirst = false;
        this.dataArr = val;
      }
      if (this.dataArr == this.$getCommonLangKey(this.companyLang)) {
        this.dataArr = data;
      }
      if (this.TrigerInit === true || this.TrigerInit === false) {
        this.dataArr = data;
      }
      if (!this.filled) this.dataArr = data; //查看模式下
    },
  },
  mounted() {
    this.canFocus = false;
    this.ban = this.banOn;
    this.dataArr = this.$getCommonLangKey(this.companyLang);
  },
  methods: {
    onError(e) {
      // console.log(e);
    },
    getLangByKey: function (key) {
      return this.companyLang.find((ele) => ele.value === key)["text"];
    },
    onFocus: function () {
      this.canFocus = true;
    },
    isObjectNull: function (obj) {
      const that = this;
      if (!obj) {
        return true;
      }
      for (let key in obj) {
        if (obj[key] == "" || obj[key] == undefined) {
          that.errorMsg =
            this.getLangByKey(key) +
            that.$t("verify_essweb_form_textField_dataIsNullTextLabel");
          return true;
        } else {
          that.errorMsg = "";
        }
      }
      return false;
    },
    onConfirm: function () {
      this.$emit("change", this.valueArr);
      this.dataArr = this.valueArr;
      this.showMenu = false;
    },
    onCancel: function () {
      const that = this;
      if (this.TrigerInit != "") {
        if (this.TrigerInit === true) {
          that.showMenu = false;
          this.$Sleep(500).then(() => {
            let data = {};
            for (let key in that.dataArr) {
              data[key] = that.dataArr[key] || "";
            }
            that.$emit("change", data);
          });
        }
      } else {
        let data = {};
        for (let key in this.dataArr) {
          data[key] = this.dataArr[key] || "";
        }
        this.showMenu = false;
        this.$emit("change", data);
      }
    },
    onKeyDown: function (key) {
      this.curKey = key;
    },
    valueChange: function (val) {
      if (this.TrigerInit != "") {
        if (this.TrigerInit == true) {
          this.valueArr[this.curKey] = val;
          // this.$emit("change", this.valueArr);
        }
      } else {
        this.valueArr[this.curKey] = val;
        this.$emit("change", this.valueArr);
      }
    },
  },
};
</script>
<style>
.text-field-width .v-input__append-inner {
  margin: 0 !important;
  /* margin-top: 3px !important; */
}
.text-field-width
  .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--single-line
  .v-input__append-inner {
  margin: 0 !important;
  /* padding-top: 3px; */
}
</style>
